/**
 * Copyright © Veeam Software Group GmbH.
 */

export const WORLD_MAP_ID = 'all';
